export const GET_BILLING_BRANCHES_REQUEST = 'GET_BILLING_BRANCHES_REQUEST';
export const GET_BILLING_BRANCHES_SUCCESS = 'GET_BILLING_BRANCHES_SUCCESS';
export const GET_BILLING_BRANCHES_FAILURE = 'GET_BILLING_BRANCHES_FAILURE';

export const GET_INVOICES_REQUEST = 'GET_INVOICES_REQUEST';
export const GET_INVOICES_SUCCESS = 'GET_INVOICES_SUCCESS';
export const GET_INVOICES_FAILURE = 'GET_INVOICES_FAILURE';

export const OVERRIDE_INVOICES_FILTERS = 'OVERRIDE_INVOICES_FILTERS';
export const SET_INVOICES_FILTERS = 'SET_INVOICES_FILTERS';
export const SET_DEFAULT_INVOICES_FILTERS = 'SET_DEFAULT_INVOICES_FILTERS';
export const RESET_INVOICES_FILTERS = 'RESET_INVOICES_FILTERS';
export const RESET_INVOICES_FILTER_CATEGORY = 'RESET_INVOICES_FILTER_CATEGORY';
export const RESET_INVOICES_FILTER_EXCEPT_CATEGORY =
  'RESET_INVOICES_FILTER_EXCEPT_CATEGORY';

export const SUBMIT_BRANCH_BILLING_ADDRESS_REQUEST =
  'SUBMIT_BRANCH_BILLING_ADDRESS_REQUEST';
export const SUBMIT_BRANCH_BILLING_ADDRESS_SUCCESS =
  'SUBMIT_BRANCH_BILLING_ADDRESS_SUCCESS';
export const SUBMIT_BRANCH_BILLING_ADDRESS_FAILURE =
  'SUBMIT_BRANCH_BILLING_ADDRESS_FAILURE';

export const UPDATE_BRANCH_BILLING_ADDRESS = 'UPDATE_BRANCH_BILLING_ADDRESS';
export const SET_ACTIVE_BRANCH = 'SET_ACTIVE_BRANCH';
export const RESET_ACTIVE_BRANCH = 'RESET_ACTIVE_BRANCH';

export const CHECK_BILLING_ZIP_REQUEST = 'CHECK_BILLING_ZIP_REQUEST';
export const CHECK_BILLING_ZIP_SUCCESS = 'CHECK_BILLING_ZIP_SUCCESS';
export const CHECK_BILLING_ZIP_ERROR = 'CHECK_BILLING_ZIP_ERROR';

export const EXPORT_INVOICE_PDF_REQUEST = 'EXPORT_INVOICE_PDF_REQUEST';
export const EXPORT_INVOICE_PDF_SUCCESS = 'EXPORT_INVOICE_PDF_SUCCESS';
export const EXPORT_INVOICE_PDF_FAILURE = 'EXPORT_INVOICE_PDF_FAILURE';
